import { connect } from 'react-redux';
import ArcadeForm from './Form';
import { createArcade, setArcadeValue, getArcade, updateArcade } from './actions';
import { getArcadeArcade } from './selectors';
import { getArcadeRoomsRooms } from 'app/components/routes/arcade/sections/rooms/selectors';

const mapStateToProps = state => {
    return {
        arcade: getArcadeArcade(state),
        roomOptions: getArcadeRoomsRooms(state),
    };
};

const mapDispatchToProps = {
    getArcade,
    createArcade,
    setArcadeValue,
    updateArcade
};

export default connect(mapStateToProps, mapDispatchToProps)(ArcadeForm);
